// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AutomationSchedule
 */
export interface AutomationSchedule {
    /**
     * Time of day (HH:mm:ss) when to start the automation
     */
    start: string | null;
    /**
     * Time of day (HH:mm:ss) when to stop the automation
     */
    end: string | null;
    /**
     * Days of Week when to execute the automation (Starting at Monday)
     */
    period: Array<number>;
}

/**
 * Check if a given object implements the AutomationSchedule interface.
 */
export function instanceOfAutomationSchedule(value: object): value is AutomationSchedule {
    if (!('start' in value) || value['start'] === undefined) return false;
    if (!('end' in value) || value['end'] === undefined) return false;
    if (!('period' in value) || value['period'] === undefined) return false;
    return true;
}

export function AutomationScheduleFromJSON(json: any): AutomationSchedule {
    return AutomationScheduleFromJSONTyped(json, false);
}

export function AutomationScheduleFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutomationSchedule {
    if (json == null) {
        return json;
    }
    return {
        
        'start': json['start'],
        'end': json['end'],
        'period': json['period'],
    };
}

export function AutomationScheduleToJSON(json: any): AutomationSchedule {
    return AutomationScheduleToJSONTyped(json, false);
}

export function AutomationScheduleToJSONTyped(value?: AutomationSchedule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'start': value['start'],
        'end': value['end'],
        'period': value['period'],
    };
}

